import { PlanAssetReadError, type PlanAssetReadErrorResult } from 'api-validations/locutus'
import type { useLocalization } from 'shared-ui/localization'

export const planAssetReadErrorMessage = (
  error: PlanAssetReadErrorResult,
  t: ReturnType<typeof useLocalization>['t']
): string =>
  error.type === PlanAssetReadError.TooLarge ? t(($) => $.planning.assetTooLarge) : error.message
